import api from "../../src/apiServices/api";

export default {
    state: {
        items: [],
        itemById: {}
    },

    getters: {},

    mutations: {
        setCompanies(state, companies) {
            state.items = companies;
        },
        setCompanyById(state, company) {
            state.itemById = company;
        }
    },

    actions: {
      fetchCompanies({ commit }, params) {
        console.log(params)
        return new Promise((resolve, reject) => {
          api.companies.getList(params)
          .then(response => {
              commit("setCompanies", response.data);
              resolve(response);
          })
          .catch(error => {
              console.log(error);
              reject(error);
            })
          })
      },

      fetchCompanyById({commit}, id) {
        if (id != null && id != undefined) {
          return new Promise((resolve, reject) => {
            api.companies
              .get(id)
              .then(response => {
                commit("setCompanyById", response.data);
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      },

      createCompany({ context }, dto) {
        console.log(context);
        console.log(dto);
        return new Promise((resolve, reject) => {
          api.companies.post(dto)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },

      updateCompany({ context }, dto) {
        console.log(context);
        return new Promise((resolve, reject) => {
          api.companies
            .put(dto)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },

      restoreCompany({context}, id) {
        console.log(context)
        console.log(id);
        if (id != null && id != undefined) {
          return new Promise((resolve, reject) => {
            api.companies
              .restore(id)
              .then(response => {
                  resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      },

      deleteCompany({context}, id) {
        console.log(context)
        console.log(id);
        if (id != null && id != undefined) {
          return new Promise((resolve, reject) => {
            api.companies
              .delete(id)
              .then(response => {
                  //fetchCompanies();
                  //commit("setCompanyById", response.data);
                  resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      }
    }
}